export const iconFontAwesomeArrowsArrowDownWideShort = (
	<i className="fa-solid fa-arrow-down-wide-short"></i>
);
